import { steps } from "./steps";

export default function determineStep(page) {
  return steps.findIndex((x) => x.pages && x.pages.indexOf(page) > -1);
}
